import React, { lazy } from 'react';
import { AnimatedSection } from '../shared/AnimatedSection';
import { DarkChatBubble } from '../shared/DarkChatBubble';
const REVIEWS_BG = 'https://cdn.shopify.com/s/files/1/0661/3847/2542/files/YP30k_u7fBp15AsfUvFQEXkcYSPiRak1qVO1lsfmZBzfMTpFtgG7EusPp9oru_abc94YZ6lBWI5wxOR0KSyLZokFbYHBWzEjruQyf9We7WavEfEed3FPuq4rD_4WmprI.jpg?v=1778629864';
export function Reviews() {
  const reviews = [{
    text: 'No esperaba que un archivo digital me hiciera sentir tanto. El Núcleo de Escorpio fue como leer mi diario interno escrito por alguien más.',
    author: 'M.R.'
  }, {
    text: 'Llevo años leyendo sobre astrología y esto es diferente. No te dice qué va a pasar. Te muestra quién eres cuando nadie está mirando.',
    author: 'A.V.'
  }, {
    text: 'Compré el reino completo de Leo y cada archivo fue una revelación. La Cámara Astral es una experiencia que no puedo explicar con palabras.',
    author: 'C.L.'
  }, {
    text: 'Pensé que conocía mi signo. El Archivo Sombrío me mostró patrones que llevaba repitiendo toda mi vida sin darme cuenta.',
    author: 'J.M.'
  }, {
    text: 'No es un PDF más. Es una experiencia completa. La atmósfera, el lenguaje, las imágenes... todo tiene sentido cuando entras a tu reino.',
    author: 'S.P.'
  }];
  return <section className="relative py-20 px-6 overflow-hidden" data-id="element-219">
      {/* Background image — lighter overlay so image breathes but chat bubbles stay readable */}
      <div className="absolute inset-0 z-0" data-id="element-220">
        <img src={REVIEWS_BG} alt="" aria-hidden="true" className="w-full h-full object-cover" loading="lazy" data-id="element-221" />
        {/* Lighter overlay than other sections */}
        <div className="absolute inset-0 bg-cosmic-black/55" data-id="element-222" />
        <div className="absolute inset-0" style={{
        background: 'linear-gradient(180deg, #050508 0%, rgba(5,5,8,0.35) 30%, rgba(5,5,8,0.35) 70%, #050508 100%)'
      }} data-id="element-223" />
      </div>

      <div className="relative z-10 container mx-auto max-w-4xl" data-id="element-224">
        <AnimatedSection data-id="element-225">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-center text-white mb-4" style={{
          textShadow: '0 2px 20px rgba(0,0,0,0.95)'
        }} data-id="element-226">
            Lo que otros sintieron
          </h2>
          <p className="text-gold-light text-center mb-16" style={{
          textShadow: '0 2px 15px rgba(0,0,0,0.95)'
        }} data-id="element-227">
            al entrar a su arquetipo
          </p>
        </AnimatedSection>

        <div className="space-y-6" data-id="element-228">
          {reviews.map((review, index) => <DarkChatBubble key={index} text={review.text} author={review.author} delay={index * 0.15} side={index % 2 === 0 ? 'left' : 'right'} data-id="element-229" />)}
        </div>
      </div>
    </section>;
}